import React from 'react';
import lc from '../styling/images/lineconditioner/lc.jpg';

const LineConditioner = () => {
    // broucher pdf
  const openPdfInNewTab = () => {
    // Replace 'path_to_your_pdf.pdf' with the actual path to your PDF file
    const pdfUrl = `/lc_broucher/lc.pdf`;
    
    // Open the PDF in a new tab
    window.open(pdfUrl, '_blank');
  };
  return <div>
    <div>
    <style>{`
        .lineconditioner {
            display: flex; 
            flex-direction: column;
            padding: 0 10px;
        }

        .lineconditioner img {
            width: 100%;
            height: auto;
        }
        
 .lineconditioner .broucher-btn{
    background-color: #0056b3;
        color: white;
        padding: 15px 30px;
        border: none;
        border-radius: 45px;
        cursor: pointer;
        font-size: 16px;
        margin-top: 10px;
        margin-bottom: 10px;
        width: auto;
        max-width: 200px;
        margin-left: auto;
        margin-right: auto; 
}

 .lineconditioner .broucher-btn:hover{
    background-color: grey;
}

        .lineconditioner h1 {
            text-align: left;
            padding-left: 20px;
            margin-top: 10px;
        }

        .lineconditioner li {
            text-align: left;
        }

        .lineconditioner table {
          width: 100%;
          border-collapse: collapse;
          margin-bottom: 50px;
        }
          /* Responsive Styles */
@media (max-width: 768px) {
    .lineconditioner h1 {
        padding-left: 10px;
        font-size: 1.5rem; /* Adjusts heading size for smaller screens */
    }

    .lineconditioner li {
        font-size: 14px; /* Adjusts list item text size */
    }

    .lineconditioner .broucher-btn {
        font-size: 14px;
        padding: 12px 24px; /* Adjusts button size for tablets */
    }

    .lineconditioner table {
        display: block;
        width: 100%;
        overflow-x: auto; /* Adds horizontal scrolling for wide tables on smaller screens */
    }

    .lineconditioner th, td {
        font-size: 11px; /* Reduces table cell font size */
        padding: 5px; /* Adjusts padding inside table cells */
    }
}

@media (max-width: 480px) {
    .lineconditioner h1 {
        padding-left: 5px;
        font-size: 1.2rem; /* Further reduces heading size for mobile */
    }

    .lineconditioner li {
        font-size: 12px; /* Adjusts list item text size for mobile */
    }

    .lineconditioner .broucher-btn {
        font-size: 12px;
        padding: 10px 20px; /* Adjusts button size for mobile */
    }

    .lineconditioner table {
        display: block;
        width: 100%;
        overflow-x: auto; /* Allows scrolling for wide tables on small screens */
    }

    .lineconditioner th, td {
        font-size: 10px; /* Reduces table cell font size further for mobile */
        padding: 4px; /* Adjusts padding for smaller screens */
    }
}
      `}</style>
    </div>
    <div className='lineconditioner'>
    <img src={lc} alt="" />
    <button className="broucher-btn" onClick={openPdfInNewTab}>Download <br /> Broucher PDF</button>
    
    <h1>Features</h1>
    <ul>
        <li>Input Voltage: Single-phase 185V-250V | Three-phase 320-430V</li>
        <li>Output voltage: Single-phase 220V | Three-phase 380V</li>
        <li>Frequency: 50Hz ± 2Hz</li>
        <li>Over voltage protection value: Single-phase 246±4V | Three-phase426 ±7V</li>
        <li>Load effect: ≤±0.5%</li>
        <li>Efficiency: greater than 90%</li>
        <li>Waveform distortion: ≤0.5%</li>
        <li>Response time: 20ms-100ms</li>
        <li>Spike voltage absorption: Input 500V 13μS | Output ≤5V</li>
        <li>Environment temp: -10℃--+40℃</li>
        <li>Temperature rise: less than 60℃</li>
        <li>Dielectric strength: 1500V/min</li>
        <li>Insulation resistance: Single-phase greater than 5MΩ | Three-phase greater than 2MΩ</li>
    </ul>

    <h1 className='specs'>Specifications</h1>
    <table>
        <thead>
            <tr>
                <th>Model</th>
                <th>Dimension (D×W×H cm)</th>
                <th>Weight (KG)</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td colspan="3"><strong>Single Phase</strong></td>
            </tr>
            <tr>
                <td>JJW-0.5 KVA</td>
                <td>41×23×33</td>
                <td>9</td>
            </tr>
            <tr>
                <td>JJW-1 KVA</td>
                <td>41×23×33</td>
                <td>10</td>
            </tr>
            <tr>
                <td>JJW-2 KVA</td>
                <td>47×24×36</td>
                <td>15</td>
            </tr>
            <tr>
                <td>JJW-3 KVA</td>
                <td>57×34×51</td>
                <td>27</td>
            </tr>
            <tr>
                <td>JJW-5 KVA</td>
                <td>57×34×51</td>
                <td>37</td>
            </tr>
            <tr>
                <td>JJW-10 KVA</td>
                <td>61×39×56</td>
                <td>65</td>
            </tr>
            <tr>
                <td>JJW-15 KVA</td>
                <td>78×54×58</td>
                <td>87</td>
            </tr>
            <tr>
                <td>JJW-20 KVA</td>
                <td>78×54×58</td>
                <td>100</td>
            </tr>
            <tr>
                <td>JJW-30 KVA</td>
                <td>94×74×70</td>
                <td>114</td>
            </tr>
            <tr>
                <td colspan="3"><strong>Three Phase</strong></td>
            </tr>
            <tr>
                <td>JSW-1.5 KVA</td>
                <td>72×44×65</td>
                <td>35</td>
            </tr>
            <tr>
                <td>JSW-3 KVA</td>
                <td>72×44×65</td>
                <td>40</td>
            </tr>
            <tr>
                <td>JSW-6 KVA</td>
                <td>72×44×65</td>
                <td>52</td>
            </tr>
            <tr>
                <td>JSW-9 KVA</td>
                <td>82×46×75</td>
                <td>91</td>
            </tr>
            <tr>
                <td>JSW-15 KVA</td>
                <td>82×46×75</td>
                <td>116</td>
            </tr>
            <tr>
                <td>JSW-20 KVA</td>
                <td>82×46×75</td>
                <td>150</td>
            </tr>
            <tr>
                <td>JSW-30 KVA</td>
                <td>82×52×85</td>
                <td>195</td>
            </tr>
            <tr>
                <td>JSW-50 KVA</td>
                <td>90×74×142</td>
                <td>232</td>
            </tr>
            <tr>
                <td>JSW-75 KVA</td>
                <td>93×83×142</td>
                <td>260</td>
            </tr>
            <tr>
                <td>JSW-100 KVA</td>
                <td>93×83×142</td>
                <td>380</td>
            </tr>
        </tbody>
    </table>
    </div>
  </div>;
};

export default LineConditioner;
